"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useIsomorphicLayoutEffect from "../../hooks/useIsomorphicLayoutEffect.js";
import { enableTransitions, disableTransitions, onNextFrame } from "../../utilities/animation.js";
import { useGlobalColorMode } from "./useTheme.js";
import { GlobalColorModeContext } from "./Theme.context.js";
import { getRootThemeEl } from "./Theme.utilities.js";
const GlobalColorMode = (props) => {
    const { defaultMode, mode: passedMode, scopeRef, children } = props;
    const [mode, setMode] = React.useState(defaultMode);
    const parentGlobalColorMode = useGlobalColorMode();
    const changeColorMode = React.useCallback((targetMode) => {
        getRootThemeEl(scopeRef?.current).setAttribute("data-rs-color-mode", targetMode);
        if (parentGlobalColorMode.mode && !scopeRef) {
            parentGlobalColorMode.setMode(targetMode);
        }
        setMode(targetMode);
    }, [scopeRef, parentGlobalColorMode]);
    useIsomorphicLayoutEffect(() => {
        disableTransitions();
        onNextFrame(() => {
            enableTransitions();
        });
    }, [mode, passedMode]);
    /**
     * In case color mode was set in html but was not provided to the provider - hydrate the state
     * This could happen if we're receiving the mode on the client but before React hydration
     */
    useIsomorphicLayoutEffect(() => {
        const nextColorMode = getRootThemeEl(scopeRef?.current).getAttribute("data-rs-color-mode");
        if (nextColorMode)
            changeColorMode(nextColorMode);
    }, [changeColorMode, scopeRef]);
    const value = React.useMemo(() => ({
        mode: passedMode || mode,
        setMode: changeColorMode,
        invertMode: () => {
            changeColorMode(mode === "light" ? "dark" : "light");
        },
    }), [mode, passedMode, changeColorMode]);
    return (_jsx(GlobalColorModeContext.Provider, { value: value, children: children }));
};
GlobalColorMode.displayName = "GlobalColorMode";
export default GlobalColorMode;
